


































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {CustomerRegisterStore} from "@/modules/customerregister/store";
import {CustomerRegisterParams} from "@/modules/customerregister/params";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import CustomerRegisterSearch from "@/modules/customerregister/List/components/Search.vue";
import CustomerRegisterTableAction from "@/modules/customerregister/List/components/TableAction.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
@Component({
    name: "customerRegisters",
    components: {CustomerRegisterTableAction, CustomerRegisterSearch, TooltipLabel}
})
export default class extends mixins(CommonMixin){
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "id",
            scopedSlots: {customRender: 'action'},
            width: 100,
            fixed: 'left'
        },
        {
            title: "Họ tên",
            dataIndex: "fullName",
            key: "fullName",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: 'fullName'}
        },
        {
            title: "Số điện thoại",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            width: 120,
            ellipsis: true,
            scopedSlots: {customRender: 'phoneNumber'}
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'email'}
        },
        {
            title: "Địa chỉ",
            dataIndex: "address",
            key: "address",
            scopedSlots: {customRender: 'address'},
            width: 150,
            ellipsis: true
        }
    ];
    
    created() {
        if (this.isAdmin) {
            this.columns = [
                ...this.columns,
                {
                    title: "Bưu cục",
                    dataIndex: "postOffice.name",
                    key: "postOfficeRowGuid",
                    width: 150,
                    ellipsis: true
                } as any
            ];
        }
        CustomerRegisterStore.updateCustomerRegisterParams(new CustomerRegisterParams())
        CustomerRegisterStore.listCustomerRegister(CustomerRegisterStore.params)
    }
    
    get customerRegisters() {
        return CustomerRegisterStore.customerRegisters
    }
    get pagination() {
        return {
            current: CustomerRegisterStore.meta.page,
            pageSize: CustomerRegisterStore.meta.limit,
            total: CustomerRegisterStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} khách hàng`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }
    
    onChangePage(pagination: any) {
        CustomerRegisterStore.listCustomerRegister({...CustomerRegisterStore.params, page: pagination.current, limit: pagination.pageSize});
    }
}
